<template>
  <div class="vue-tempalte">

    <div class="container-login ">
      <div v-if="loading">
        <div class="screen-login flex-center">
          <div class="spinner-border spinner-border-sm text-black" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <div class="login-card ">
        <div class="text-center">
          <img src='../assets/logo.png' width="40" style="border-radius: 4px;" />
        </div>
        <div class="m-4 font-size-h5" style="text-align: center;">เข้าสู่ระบบด้วย</div>
        <button type="submit" class="btn btn-light btn-lg  mt-2 w-100" @click="loginWithGoogle()">
          <div class="d-flex  justify-content-center">
            <img src='../assets/logo-google.png' width="18" style="border-radius: 4px;margin-right: 4px;" />
            <div>Google</div>
            <div></div>
          </div>

        </button>
        <!-- <button type="submit" class="btn btn-facebook btn-lg  mt-2 w-100" @click="loginWithFacebook()">
          <div class="d-flex  justify-content-center">
            <i class="bi-facebook" style="color: white; font-size:14px; margin-right: 4px;"></i>

            <div>Facebook </div>
            <div></div>
          </div>
        </button> -->
      </div>


    </div>
    <div class="font-size-h6 text-center text-checking">© 2024 Shoppong. All rights reserved. Textoyou Co., Ltd.</div>

  </div>
</template>

<script>
import { auth, googleProvider } from '@/firebase'
import { signInWithPopup } from 'firebase/auth'
export default {
  data() {
    return {
      user: {
        phone: '',
      },
      loading: false
    };
  },
  async created() {
    console.log(this.$store.getters.getUserData)

  },
  methods: {
    async loginWithGoogle() {
      try {
        this.loading = true

        const result = await signInWithPopup(auth, googleProvider)
        const user = result.user
        const idToken = await user.getIdToken()

        // ส่ง token ไป backend
        const access = await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/auth`, {
          idToken,
        })

        const { displayName, email, uid } = user

        this.$store.dispatch('setUserData', { name: displayName, email, uid })
        this.$store.dispatch('setToken', access.data.jwtToken)

        const history = await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/history/`, { uid: uid, token: access.data.jwtToken, },)

        this.$store.dispatch('setHistory', history.data.data)


        this.$router.push('/home')
      } catch (err) {
        this.loading = false
        alert(err.message)
      }
    },

  },

};
</script>
<style>
.container-login {
  display: flex;
  justify-content: center;
  /* จัดตำแหน่งแนวนอน */
  align-items: center;
  /* จัดตำแหน่งแนวตั้ง */
  height: 90vh;
  /* ความสูงเต็มหน้าจอ */
  width: 100%;
  /* ความกว้างเต็มหน้าจอ */
  /* สีพื้นหลัง (ตัวเลือก) */

}

/* .login-card {
  border-radius: 20px;
  height: 320px;
  width: 320px;
  padding: 40px;
  justify-content: center;
  align-items: center;

} */

.btn-facebook {
  background-color: #1877F2;
  color: #fff;
}

.btn-facebook:hover {
  background-color: #4b99ff;
  color: #fff;
}
</style>